// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.stepper-wrapper[data-v-69622b80] {\r\n  height: 100%;\r\n  width: 100%;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n  padding: 0;\n}\n.v-radio[data-v-69622b80] .v-label {\r\n  margin: 0 !important;\n}\r\n/*.row {\r\n  border: solid 1px orange;\r\n}\r\n.col {\r\n  border: solid 1px red;\r\n}*/\r\n", ""]);
// Exports
module.exports = exports;
